export default {
  styleOverrides: {
    root: {
      display: "block",
    },
  },
};
